import { render, staticRenderFns } from "./ChartsPlugin.vue?vue&type=template&id=4f972e62&scoped=true"
import script from "./ChartsPlugin.vue?vue&type=script&lang=ts"
export * from "./ChartsPlugin.vue?vue&type=script&lang=ts"
import style0 from "./ChartsPlugin.vue?vue&type=style&index=0&id=4f972e62&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f972e62",
  null
  
)

export default component.exports